import "./tab-nav.style.scss";

export interface TabNavItem {
	key: string;
	label: string;
}

interface TabNavProps {
	tabs: TabNavItem[];
	activeKey: string;
	onChange: (key: string) => void;
}

export default function TabNav({ tabs, activeKey, onChange }: TabNavProps) {
	return (
		<div className="tab-nav" role="tablist">
			{tabs.map((tab) => (
				<button
					key={tab.key}
					type="button"
					role="tab"
					aria-selected={activeKey === tab.key}
					className={`tab-nav-item ${activeKey === tab.key ? "active" : ""}`}
					onClick={() => onChange(tab.key)}
				>
					{tab.label}
				</button>
			))}
		</div>
	);
}
